const colors = {
  white: '#ffffff',
  warningAmber: '#FFC107',
  warningAmberLight: '#FFFDE7',
  warningAmberBorder: '#FFE082',
  warningAmberText: '#92400E',
  drugIconBg: '#EEF2FF',
  drugIconColor: '#6366F1',
  inventoryLockOrange: '#E65100',
  inventoryLockOrangeLight: '#FFF8F5',
  inventoryLockOrangeBorder: '#FFCCBC',
  // Table head background for the inventory tables. Same value as
  // dialogCloseNavy today but kept separate: one is a dialog control, the other
  // a table surface, and they should be free to diverge.
  tableHeaderNavy: '#0d1f35',
  // The rule between inventory table header cells. AG Grid draws it from the resize handle,
  // so a column that cannot be resized has to paint its own and must match exactly.
  tableHeaderSeparator: 'rgba(255,255,255,0.45)',
  dialogCloseNavy: '#0d1f35',
  dialogCloseNavyHover: '#1a3a5c',
  lockedCellGrey: '#F3F4F6',
  lockedCellGreyIcon: '#6B7280',
  lockedCellBorder: '#D1D5DB',
  // Sig Management's manage-association dialog. A card sits on a tinted page surface, and the
  // pending-changes card is tinted again so the one block that has not been written yet reads as
  // provisional rather than as more of the same data.
  cardBorderGrey: '#E5E7EB',
  dialogSurfaceGrey: '#F9FAFB',
  pendingChangesBlue: '#EFF6FF',
  pendingChangesBlueBorder: '#BFDBFE',
  // Patient profile partner contacts. A field changed from what is on file stays tinted until it
  // is saved, and its section carries an "Edited" chip in the same blue.
  editedFieldBlue: '#f3f8fd',
  editedFieldBlueBorder: 'rgba(25,118,210,0.6)',
  editedFieldBlueLabel: '#1565c0',
  editedChipBlue: 'rgba(25,118,210,0.08)',
  subtleDivider: 'rgba(0,0,0,0.08)',
  // The "Default" pill on the patient's own email and phone.
  defaultContactChipSurface: '#e3effc',
  defaultContactChipText: '#1976d2',
  // An inline warning Alert. The theme's warning palette is navy, so severity='warning' alone does
  // not read as a warning.
  warningAlertSurface: '#fff4e5',
  warningAlertText: '#663c00',
  warningAlertIcon: '#ed6c02',
  // Review Lot & NDC. The read-only stripe marks Already dispensed / Locked for count rows; the
  // highlight flashes a row that has just moved to another group.
  reviewReadOnlyStripe: '#b3bac6',
  reviewRowMovedHighlight: '#dbe9fb',
  reviewHeaderTitleInk: '#0F172A',
  reviewHeaderSubtitleInk: '#2B3648',
  reviewHeaderCloseInk: '#4A5568',
  offageReasonsSurface: '#fff8e1',
};

export default colors;
